import styled from 'styled-components';

import { Button as ButtonLayoutComponent, Text as TextLayoutComponent } from '@playbookux/playbook-web-core';
import SearchLayoutComponent from '../../../../../core/layout-components/search';

const Container = styled.div`
  overflow-y: scroll;
  flex: 1;
  padding-right: 10px;
`;

const AddButton = styled(ButtonLayoutComponent)``;

const ContainerButton = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin-top: 30px;
  align-items: center;
`;

const ContainerBottom = styled.div``;

const TextTotal = styled(TextLayoutComponent)``;

const ClearButton = styled.a``;

const ContainerInputSearch = styled.div`
  padding: 30px 0;
  z-index: 1;
  background-color: white;
  position: sticky;
  top: 0;
  display: flex;
  flex-direction: row;
`;

const InputSearch = styled(SearchLayoutComponent)`
  &&&&&& {
    width: 100%;
  }
  & > :first-child {
    width: 100%;
  }
`;

const ContainerDropdown = styled.div`
  margin-left: 20px;
`;

export {
  Container,
  AddButton,
  ContainerButton,
  ContainerBottom,
  TextTotal,
  ClearButton,
  ContainerInputSearch,
  InputSearch,
  ContainerDropdown,
};
